import { SERVER_API_URL } from "../app.constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class ActivityTypeService {
    private resourceUrl = SERVER_API_URL + 'api/activity-types';

    constructor(
        private http: HttpClient) {
    }

    getActivityTypes(includeInactive = false): Observable<HttpResponse<Nema.Crew.Model.ActivityType[]>> {
        return this.http
            .get < Nema.Crew.Model.ActivityType[]>(`${this.resourceUrl}?includeInactive=${includeInactive}`, { observe: 'response' })
            .map((res: HttpResponse<Nema.Crew.Model.ActivityType[]>) => this.convertArrayResponse(res));
    }

    //private _convertResponse(res: HttpResponse<Nema.Crew.Model.ActivityType>): HttpResponse<Nema.Crew.Model.ActivityType> {
    //    const body: Nema.Crew.Model.ActivityType = this.convertItemFromServer(res.body);
    //    return res.clone({ body });
    //}

    private convertArrayResponse(res: HttpResponse<Nema.Crew.Model.ActivityType[]>): HttpResponse<Nema.Crew.Model.ActivityType[]> {
        const jsonResponse: Nema.Crew.Model.ActivityType[] = res.body;
        const body: Nema.Crew.Model.ActivityType[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }

        return res.clone({ body });
    }

    private convertItemFromServer(activityType: Nema.Crew.Model.ActivityType): Nema.Crew.Model.ActivityType{
        const copy: Nema.Crew.Model.ActivityType = Object.assign({}, activityType);
        return copy;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/activity-type.service.ts